import { Textarea } from '@mantine/core';
import { RENDER_MODELS, RENDER_WISHES_MAX_LENGTH, renderWishesMaxLength, type RenderModelCode } from '@erp/shared';

const MODEL_LABELS = Object.fromEntries(RENDER_MODELS.map((m) => [m.code, m.label])) as Record<string, string>;

export function wishesTooLong(wishes: string, model: RenderModelCode): boolean {
  return wishes.trim().length > renderWishesMaxLength(model);
}

/**
 * Пожелания заказчика к визуализации. Без maxLength: браузер молча обрезал
 * бы вставленное ТЗ, и нейросеть получила бы его без концовки. Вместо этого
 * счётчик и ошибка — прораб сам решит, что сократить, или выберет модель с
 * более длинным запросом.
 */
export function WishesInput({
  value,
  onChange,
  model,
  disabled,
}: {
  value: string;
  onChange: (value: string) => void;
  model: RenderModelCode;
  disabled?: boolean;
}) {
  const max = renderWishesMaxLength(model);
  const length = value.trim().length;
  const tooLong = length > max;
  return (
    <Textarea
      size="xs"
      label="Пожелания заказчика"
      placeholder="Например: светлый дуб, зелёный бархатный диван, много света"
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
      disabled={disabled}
      autosize
      minRows={1}
      maxRows={10}
      // Счётчик — только когда текст длинный: короткие пожелания он лишь отвлекает.
      description={!tooLong && length > max * 0.7 ? `${length} из ${max} символов` : undefined}
      error={
        tooLong
          ? `${length} из ${max} символов — сократите${max < RENDER_WISHES_MAX_LENGTH ?` или выберите другую нейросеть: у ${MODEL_LABELS[model]} запрос короче` : ''}`
          : undefined
      }
      style={{ flex: '1 1 260px' }}
    />
  );
}
